import { render, staticRenderFns } from "./BrowseAssessmentsFilters.vue?vue&type=template&id=bcab1ab2&scoped=true"
import script from "./BrowseAssessmentsFilters.vue?vue&type=script&lang=js"
export * from "./BrowseAssessmentsFilters.vue?vue&type=script&lang=js"
import style0 from "./BrowseAssessmentsFilters.vue?vue&type=style&index=0&id=bcab1ab2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcab1ab2",
  null
  
)

export default component.exports